<div class="card" *appIsGranted="['PACKETS_STATUS', 'PACKETS_STATUS', 'READ']">
  <div class="card-body column">
    <div class="row">
      <h6 class="card">Status</h6>
      <div class="col-md-10">
        <label>Serial</label>
        <input class="w-100" placeholder="205502151" [(ngModel)]="seriais" />
      </div>
      <div class="col-md-2">
        <div class="row w-75 ms-4">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="search()"
          >
            Pesquisar
          </button>
        </div>
      </div>
      <div class="col-md-2 d-inline">
        <input
          class="form-check-input ms-2"
          type="radio"
          name="formRadios"
          id="formRadios1"
          value="0"
          [(ngModel)]="prettyEvent"
          checked
        />
        <label class="form-check-label" for="formRadios1"> 0 </label>
        <input
          class="form-check-input ms-2"
          type="radio"
          name="formRadios"
          id="formRadios2"
          value="1"
          [(ngModel)]="prettyEvent"
        />
        <label class="form-check-label" for="formRadios2"> 1 </label>
        <input
          class="form-check-input ms-2"
          type="radio"
          name="formRadios"
          id="formRadios3"
          value="2"
          [(ngModel)]="prettyEvent"
        />
        <label class="form-check-label" for="formRadios2"> 2 </label>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card-body">
    <!-- Nav tabs -->
    <ul
      ngbNav
      #customNav="ngbNav"
      [activeId]="1"
      class="nav nav-tabs nav-tabs-custom"
      (activeIdChange)="changeTab(customNav)"
    >
      <li [ngbNavItem]="1">
        <a ngbNavLink>
          <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
          <span class="d-none d-sm-block">MXT</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="TabMXT"></ng-template>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink>
          <span class="d-block d-sm-none"><i class="fa-automobile"></i></span>
          <span class="d-none d-sm-block">BWS</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="TabBWS"></ng-template>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a ngbNavLink>
          <span class="d-block d-sm-none"><i class="fa-amazon"></i></span>
          <span class="d-none d-sm-block">Suntech</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="TabSuntech"></ng-template>
        </ng-template>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content p-3 text-muted">
      <div [ngbNavOutlet]="customNav"></div>
    </div>
  </div>
</div>

<!-- Tab MXT-->
<ng-template #TabMXT>
  <ul
    ngbNav
    #customNavMXT="ngbNav"
    [activeId]="1"
    class="nav nav-tabs nav-tabs-custom"
  >
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
        <span class="d-none d-sm-block">Status</span>
      </a>
      <ng-template ngbNavContent>
        <ng-template [ngTemplateOutlet]="TabMXT1"></ng-template>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>
        <span class="d-block d-sm-none"><i class="fa-dashboard"></i></span>
        <span class="d-none d-sm-block">Análise</span>
      </a>
      <ng-template ngbNavContent>
        <ng-template [ngTemplateOutlet]="TabMXT2"></ng-template>
      </ng-template>
    </li>
  </ul>

  <!-- Tab panes -->
  <div class="tab-content p-3 text-muted">
    <div [ngbNavOutlet]="customNavMXT"></div>
  </div>
</ng-template>

<ng-template #TabMXT1>
  <div class="card overflow-auto">
    <div class="card-body">
      <table class="table table-fit table-bordered table-hover">
        <thead class="table-primary">
          <tr>
            <th class="text-center" scope="col-md-2">Serial</th>
            <th class="text-center" scope="col-md-4">Data</th>
            <th class="text-center" scope="col-md-6">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of status; let i = index">
            <td class="text-center" scope="row">{{ item.serial }}</td>
            <td
              class="text-center"
              style="white-space: nowrap !important"
              scope="row"
            >
              {{ getdate(item) }}
            </td>
            <td class="" scope="row">
              <div>
                <div *ngIf="prettyEvent == '0'">
                  <ngx-json-viewer
                    [json]="item.status"
                    [depth]="1"
                  ></ngx-json-viewer>
                </div>

                <div *ngIf="prettyEvent == '1'">
                  <ngx-json-viewer
                    [json]="item.status"
                    [expanded]="false"
                  ></ngx-json-viewer>
                </div>
                <div *ngIf="prettyEvent == '2'">
                  <p [innerHTML]="item.status | json"></p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
<!-- Tab MXT2 Analytics-->
<ng-template #TabMXT2>
  <div class="card overflow-auto">
    <div>
      <button class="btn btn-sm btn-primary" (click)="copyToClipboardMXT()">
        Copiar para área de transferência dados
      </button>
    </div>
  </div>
</ng-template>
<!-- Tab BWS-->
<ng-template #TabBWS>
  <div class="card overflow-auto">
    <div class="card-body">
      <table class="table table-fit table-bordered table-hover">
        <thead class="table-primary">
          <tr>
            <th class="text-center" scope="col-md-2">Serial</th>
            <th class="text-center" scope="col-md-4">Data</th>
            <th class="text-center" scope="col-md-6">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of status; let i = index">
            <td class="text-center" scope="row">{{ item.serial }}</td>
            <td
              class="text-center"
              style="white-space: nowrap !important"
              scope="row"
            >
              {{ getdate2(item) }}
            </td>
            <td class="" scope="row">
              <div>
                <div *ngIf="prettyEvent == '0'">
                  <ngx-json-viewer
                    [json]="getStatus(item.status)"
                    [depth]="1"
                  ></ngx-json-viewer>
                </div>

                <div *ngIf="prettyEvent == '1'">
                  <ngx-json-viewer
                    [json]="getStatus(item.status)"
                    [expanded]="false"
                  ></ngx-json-viewer>
                </div>
                <div *ngIf="prettyEvent == '2'">
                  <p [innerHTML]="getStatus(item.status) | json"></p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
<ng-template #TabSuntech>
  <div class="card overflow-auto">
    <div class="card-body">
      <table class="table table-fit table-bordered table-hover">
        <thead class="table-primary">
          <tr>
            <th class="text-center" scope="col-md-2">Serial</th>
            <th class="text-center" scope="col-md-4">
              Data Recebimento<br />Data Atualização por comando
            </th>
            <th class="text-center" scope="col-md-6">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of status; let i = index">
            <td class="text-center" scope="row">
              {{ item.serial }}
            </td>
            <td
              class="text-center"
              style="white-space: nowrap !important"
              scope="row"
            >
              {{ getdate2(item) }} <br />
              {{ getdate3(item) }}
            </td>
            <td class="" scope="row" style="overflow-wrap: anywhere">
              <div>
                <div *ngIf="prettyEvent == '0'">
                  <ngx-json-viewer
                    [json]="getStatus(item.status)"
                    [depth]="1"
                  ></ngx-json-viewer>
                </div>

                <div *ngIf="prettyEvent == '1'">
                  <ngx-json-viewer
                    [json]="getStatus(item.status)"
                    [expanded]="false"
                  ></ngx-json-viewer>
                </div>
                <div *ngIf="prettyEvent == '2'">
                  <p [innerHTML]="getStatus(item.status) | json"></p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div></div
></ng-template>
